export const ROADMAP_TEMPLATES = [
    {
        id: 'spring-boot-rest-apis',
        title: 'Spring Boot REST APIs',
        emoji: '☕',
        category: 'Computer Science',
        level: 'BEGINNER',
        estimatedHours: 36,
        summary: 'Move from Spring fundamentals to a tested, production-ready REST API.',
        goal: 'Build and deploy maintainable REST APIs with Spring Boot.',
        skills: ['Spring MVC', 'JPA', 'Testing', 'API design'],
        modules: [
            {title: 'Spring foundations', description: 'Understand the application model and dependency injection.', topics: [{title: 'Spring Boot project setup', estimatedMinutes: 90}, {title: 'Dependency injection', estimatedMinutes: 120}, {title: 'Configuration and profiles', estimatedMinutes: 90}]},
            {title: 'REST API design', description: 'Design controllers, validation, and consistent API responses.', topics: [{title: 'Controllers and request mapping', estimatedMinutes: 150}, {title: 'DTOs and validation', estimatedMinutes: 120}, {title: 'Error handling', estimatedMinutes: 90}]},
            {title: 'Persistence and production', description: 'Persist data, test behavior, and prepare the API for release.', topics: [{title: 'Spring Data JPA', estimatedMinutes: 180}, {title: 'Integration testing', estimatedMinutes: 150}, {title: 'Security and deployment', estimatedMinutes: 180}]},
        ],
    },
    {
        id: 'data-structures-algorithms',
        title: 'Data Structures & Algorithms',
        emoji: '🧠',
        category: 'Computer Science',
        level: 'INTERMEDIATE',
        estimatedHours: 48,
        summary: 'Build practical problem-solving fluency with core structures and algorithm patterns.',
        goal: 'Choose efficient data structures and solve common algorithmic problems confidently.',
        skills: ['Complexity analysis', 'Trees', 'Graphs', 'Dynamic programming'],
        modules: [
            {title: 'Complexity and linear structures', description: 'Measure performance and master arrays, lists, stacks, and queues.', topics: [{title: 'Big O analysis', estimatedMinutes: 120}, {title: 'Arrays and linked lists', estimatedMinutes: 150}, {title: 'Stacks and queues', estimatedMinutes: 120}]},
            {title: 'Trees and graphs', description: 'Model hierarchical and connected data.', topics: [{title: 'Binary trees', estimatedMinutes: 180}, {title: 'Graph traversal', estimatedMinutes: 180}, {title: 'Shortest paths', estimatedMinutes: 150}]},
            {title: 'Problem-solving patterns', description: 'Apply reusable techniques to harder problems.', topics: [{title: 'Two pointers and sliding windows', estimatedMinutes: 150}, {title: 'Backtracking', estimatedMinutes: 180}, {title: 'Dynamic programming', estimatedMinutes: 240}]},
        ],
    },
    {
        id: 'digital-marketing-foundations',
        title: 'Digital Marketing Foundations',
        emoji: '📈',
        category: 'Marketing',
        level: 'BEGINNER',
        estimatedHours: 24,
        summary: 'Plan, launch, and measure a focused digital campaign from audience to reporting.',
        goal: 'Create and evaluate a multi-channel digital marketing campaign.',
        skills: ['Positioning', 'Content strategy', 'SEO', 'Analytics'],
        modules: [
            {title: 'Audience and positioning', description: 'Define who you serve and why the offer matters.', topics: [{title: 'Customer segments', estimatedMinutes: 90}, {title: 'Value proposition', estimatedMinutes: 90}]},
            {title: 'Channels and content', description: 'Choose channels and build a repeatable content system.', topics: [{title: 'Content strategy', estimatedMinutes: 120}, {title: 'SEO fundamentals', estimatedMinutes: 150}, {title: 'Paid campaign basics', estimatedMinutes: 120}]},
            {title: 'Measurement', description: 'Turn campaign data into useful decisions.', topics: [{title: 'Marketing funnels', estimatedMinutes: 90}, {title: 'Core metrics and attribution', estimatedMinutes: 120}]},
        ],
    },
    {
        id: 'business-english',
        title: 'Business English Essentials',
        emoji: '🌍',
        category: 'Languages',
        level: 'INTERMEDIATE',
        estimatedHours: 30,
        summary: 'Communicate clearly in meetings, presentations, email, and everyday professional situations.',
        goal: 'Communicate confidently and clearly in an English-speaking workplace.',
        skills: ['Business vocabulary', 'Email writing', 'Meetings', 'Presentations'],
        modules: [
            {title: 'Clear workplace communication', description: 'Use concise language for common professional situations.', topics: [{title: 'Professional vocabulary', estimatedMinutes: 120}, {title: 'Clear email writing', estimatedMinutes: 150}]},
            {title: 'Meetings and collaboration', description: 'Participate, clarify, and align with colleagues.', topics: [{title: 'Leading and joining meetings', estimatedMinutes: 150}, {title: 'Agreeing and disagreeing', estimatedMinutes: 90}, {title: 'Negotiation language', estimatedMinutes: 120}]},
            {title: 'Presenting ideas', description: 'Structure and deliver a persuasive professional presentation.', topics: [{title: 'Presentation structure', estimatedMinutes: 120}, {title: 'Delivery and Q&A', estimatedMinutes: 150}]},
        ],
    },
];

export const ROADMAP_TEMPLATE_CATEGORIES = [...new Set(ROADMAP_TEMPLATES.map((template) => template.category))];

